export default __webpack_public_path__ + "static/725-2122a70a47581c17af48e6c97fdc270f.gif";